import React from 'react';

import { Button, Stack } from '@mui/material';

import UnsavedChangesInfoIcon from '~/components/Common/Elements/UnsavedChangesInfoIcon';

type VoucherFormNavigationProps = {
  isSubmitting: boolean;
  hasUnsavedChanges: boolean;
  isEdit: boolean;
  onBack: () => void;
  onOpenClone?: () => void;
};

export default function VoucherFormNavigation({
  isSubmitting,
  hasUnsavedChanges,
  isEdit,
  onBack,
  onOpenClone,
}: VoucherFormNavigationProps) {
  return (
    <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap" alignItems="center">
      <Button variant="text" onClick={onBack} disabled={isSubmitting}>
        Back to list
      </Button>
      <UnsavedChangesInfoIcon hasUnsavedChanges={hasUnsavedChanges} />
      {isEdit && onOpenClone && (
        <Button variant="text" onClick={onOpenClone} disabled={isSubmitting}>
          Clone
        </Button>
      )}
    </Stack>
  );
}
